import { styled } from '@mui/material';

export const TableWrapper = styled('div')({
  maxHeight: 210,
  overflowY: 'auto',
});
